<div class="d-flex">
	<div class="p-grid">
		<div class="p-col-12 p-md-6">
			<div class="p-grid">
				<ng-container *ngFor="let item of displaySummary1thru5; let idx = index">
					<div class="col-9 display-14">
						<span class="text-italics me-2">
							{{ idx + 1 }}
						</span>
						{{ item.name }}
					</div>
					<div class="col-3 display-14">
						<div *ngIf="sortType === 'sales'">
							{{ item.revenue | currency }}
						</div>
						<div *ngIf="sortType === 'quantity'">
							{{ item.quantity }}
						</div>
					</div>
				</ng-container>
			</div>
		</div>
		<div class="p-col-12 p-md-6">
			<div class="p-grid">
				<ng-container *ngFor="let item of displaySummary6thru10; let idx = index">
					<div class="col-9 display-14">
						<span class="text-italics me-2">
							{{ idx + 6 }}
						</span>
						{{ item.name }}
					</div>
					<div class="col-3 display-14">
						<div *ngIf="sortType === 'sales'">
							{{ item.revenue | currency }}
						</div>
						<div *ngIf="sortType === 'quantity'">
							{{ item.quantity }}
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
</div>
